module.exports = __webpack_public_path__ + "static/media/touch_background.56a96b9b.png";